import '../snippets/quick-shop'
import $ from 'cash-dom'
import { initCarousel } from '../snippets/carousel'

$(() => {
  initCarousel('.product-carousel')
  initCarousel('.reviews-carousel')
})
